import project from "./project"

const config = {
  wherewego: [] as string[],
  skillup: ['Dallas'] as string[],
}

const excludedCatalogs = config[project];

export default excludedCatalogs;